// extracted by mini-css-extract-plugin
module.exports = {"container":"Players_container__2NRz4","fake_player":"Players_fake_player__EqawV"};